import { uniq } from "lodash";
import React from "react";

import { CustomType } from "../types";
import { Field } from "./field";

type CustomFieldProps = {
  className?: string;
  customTypes: CustomType[];
  names: string[];
  title: string;
  contentClassName?: string;
};

export const CustomField = ({ contentClassName, className, customTypes, names, title }: CustomFieldProps) => {
  const values = (names || [])
    .reduce((acc, name) => {
      const customType = customTypes.find(({ type }) => type.name === name);
      if (customType) {
        const vals = customType.text ? customType.text.split("\r ") : [];
        return [...acc, ...vals];
      }
      return acc;
    }, [])
    .sort((v1, v2) => v1.toLowerCase().localeCompare(v2.toLowerCase()));

  if (values.length === 0) {
    return null;
  }

  return (
    <Field title={title} className={className} textClassName={contentClassName}>
      <ul>
        {uniq(values).map((item) => (
          <li key={item}>
            <div>{item}</div>
          </li>
        ))}
      </ul>
    </Field>
  );
};
